import {
  responsiveWidth,
  responsiveHeight,
} from 'react-native-responsive-dimensions';

export const sizes = {
  width: responsiveWidth(100),
  height: responsiveHeight(100),
};
